module.exports = {
  ProductData: () => {
    return [
      {
        "id": "master1000",
        "name" : "Master 1000",
        "fullname" : "Cubierta Master 1000",
        "background" : require("../assets/backgrounds/Master1000.webp"),
        "decal" : {
          "position" : {"x": 1.48, "y": -0.009, "z": -0.64},
          "rotation" : {"x": 0, "y": 0, "z": 0},
          "scaling" : {"x": .2241, "y": 1, "z": .0470}
        },
        "interactable" : true,
        "active" : true
      },
      {
        "id": "canaleta",
        "name" : "Canaleta",
        "fullname" : "Canaleta",
        "background" : require("../assets/backgrounds/Canaleta.webp"),
        "decal" : {
          "position" : {"x": 1.55, "y": -0.003, "z": -0.548},
          "rotation" : {"x": -55, "y": 0, "z": 0},
          "scaling" : {"x": .2241, "y": 1, "z": .0470}
        },
        "interactable" : true,
        "active" : true
      },
      {
        "id": "arquitectonica",
        "name" : "Arquitectónica",
        "fullname" : "Cubierta Arquitectónica",
        "background" : require("../assets/backgrounds/Arquitectonica.webp"),
        "decal" : {
          "position" : {"x": 1.53, "y": -0.005, "z": -0.68},
          "rotation" : {"x": 0, "y": 0, "z": 0},
          "scaling" : {"x": .2241, "y": 1, "z": .0470}
        },
        "interactable" : true,
        "active" : true
      },
      {
        "id": "sintraslapo",
        "name" : "Sin Traslapo",
        "fullname" : "Teja Sin Traslapo",
        "background" : require("../assets/backgrounds/SinTraslapo.webp"),
        "decal" : {
          "position" : {"x": 1.5, "y": -0.022, "z": -0.6},
          "rotation" : {"x": 0, "y": 0, "z": 0},
          "scaling" : {"x": .2241, "y": 1, "z": .0470}
        },
        "interactable" : true,
        "active" : true
      },
      {
        "id": "metaldeck",
        "name" : "Metaldeck",
        "fullname" : "Metaldeck",
        "background" : require("../assets/backgrounds/Metaldeck.webp"),
        "decal" : {
          "position" : {"x": 1.47, "y": 0.008, "z": -0.723},
          "rotation" : {"x": 0, "y": 0, "z": 0},
          "scaling" : {"x": .2241, "y": 1, "z": .0470}
        },
        "folder360" : "./models/360/metaldeck/",
        "interactable" : true,
        "active" : true
      },
    ]
  }
}